
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '原产国名称',
value: this.$route.params.OC_NAME
}, {
label: '原产国说明',
value: this.$route.params.OC_Remark
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_OriginCountryDetail.vue